import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    letterWrapper: {
        display: 'flex',
    },
    normalLetter: {
        display: 'flex',
        position: 'relative',
    },
    smallLetter: {
        position: 'absolute',
        bottom: 0,
        fontSize: '8px',
    },
});
